import { LocationType } from '@/types';
import { Core, LOCATION_TYPES } from '../Core';

class LocationTypes extends Core {
  getLocationTypes = async () => this.get<LocationType[]>(LOCATION_TYPES());
}

export const locationTypes = new LocationTypes();
